var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressReleasesTotalCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0156 30.9375V0H0.390625V45.1562C0.390625 47.8125 2.57812 50 5.23438 50H44.7656C47.4219 50 49.6094 47.8125 49.6094 45.1562V30.9375H41.0156ZM5.23438 48.8281C3.20312 48.8281 1.48438 47.1875 1.48438 45.0781V1.17188H39.8438V45.1562C39.8438 46.6406 40.5469 47.9688 41.5625 48.9062H5.23438V48.8281ZM48.5156 45.1562C48.5156 47.1875 46.875 48.9062 44.7656 48.9062C42.7344 48.9062 41.0156 47.2656 41.0156 45.1562V32.1094H48.5156V45.1562Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 3.90625H3.90625V14.0625H25V3.90625ZM23.9062 12.9688H5.07812V5.07812H23.9062V12.9688Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 14.0625H37.1094V3.90625H27.1875V14.0625ZM28.2813 5.07812H35.9375V12.9688H28.2813V5.07812Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 22.8906H10.8594V24.0625H12.0312V22.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 22.8906H7.73438V24.0625H8.90625V22.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2812 22.8906H17.1094V24.0625H18.2812V22.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78125 22.8906H4.60938V24.0625H5.78125V22.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1562 22.8906H13.9844V24.0625H15.1562V22.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5H13.8281V18.6719H15V17.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 17.5H4.45312V18.6719H5.625V17.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 17.5H7.57812V18.6719H8.75V17.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 17.5H17.0312V18.6719H18.2031V17.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 17.5H10.7031V18.6719H11.875V17.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 22.8906H22.7344V24.0625H36.4844V22.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 17.5H22.7344V18.6719H36.4844V17.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 28.2031H4.45312V29.375H18.2031V28.2031Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 28.2031H22.7344V29.375H36.4844V28.2031Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 33.5938H4.45312V34.7656H18.2031V33.5938Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 33.5938H22.7344V34.7656H36.4844V33.5938Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 38.9844H4.45312V40.1562H18.2031V38.9844Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 38.9844H35.3906V40.1562H36.5625V38.9844Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 38.9844H32.2656V40.1562H33.4375V38.9844Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 38.9844H22.8906V40.1562H24.0625V38.9844Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 38.9844H26.0156V40.1562H27.1875V38.9844Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3125 38.9844H29.1406V40.1562H30.3125V38.9844Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 37.8906H44.1406V39.0625H45.3125V37.8906Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 41.3281H44.1406V42.5H45.3125V41.3281Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 34.4531H44.1406V35.625H45.3125V34.4531Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3125 44.7656H44.1406V45.9375H45.3125V44.7656Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 44.2969H4.45312V45.4688H18.2031V44.2969Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 44.2969H22.7344V45.4688H36.4844V44.2969Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressReleasesTotalCount);
export default __webpack_public_path__ + "static/media/pressReleasesTotalCount.bffe82981f44ede65831659c751eaf20.svg";
export { ForwardRef as ReactComponent };